import React from 'react'
import Header from '../components/Header'

import Privacy from '../components/Privacy'
import { Helmet } from 'react-helmet'

export default function WebPrivacy() {
  return (
    <div>
                  <Helmet>
        <title>Features | Andromeda</title>
        <meta name="description" content="Get in touch with us through our contact page." />
        <meta name="keywords" content="contact, support, help, andromeda sim" />
      </Helmet>
        <div className=''><Header/></div>
        <Privacy/>
    </div>
  )
}
